import { render, staticRenderFns } from "./BlockTagsEdit.vue?vue&type=template&id=7f3a2ec1&"
import script from "./BlockTagsEdit.vue?vue&type=script&lang=ts&"
export * from "./BlockTagsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports